export const RECRUITMENT_FILTER_TYPES = ['sourcing', 'urgent', 'toAssign', 'filled'];

export const RECRUITMENT_FILTER_OPTIONS = [
  {
    type: 'sourcing',
    name: 'Sourcing',
    description: 'Recherche de candidats pour des besoins futurs',
  },
  {
    type: 'urgent',
    name: 'Urgente',
    description: 'Mission à pourvoir pour aujourd\'hui',
  },
  {
    type: 'toAssign',
    name: 'À pourvoir',
    description: null,
  },
  {
    type: 'filled',
    name: 'Pourvue',
    description: null,
  },
];

export const parseRecruitmentSearchParam = (recruitmentParam, { assigned, sourcing } = {}) => {
  if (recruitmentParam) {
    return recruitmentParam
      .split(',')
      .filter((type) => RECRUITMENT_FILTER_TYPES.includes(type));
  }

  const migrated = [];
  if (assigned === 'true') migrated.push('filled');
  if (assigned === 'false') migrated.push('toAssign');
  if (sourcing === 'true') migrated.push('sourcing');
  return migrated;
};

export const migrateSavedRecruitmentSearch = (saved = {}) => {
  if (Array.isArray(saved.recruitmentSearch)) {
    return saved.recruitmentSearch.filter((type) => RECRUITMENT_FILTER_TYPES.includes(type));
  }

  const migrated = [];
  if (saved.assigned === true) migrated.push('filled');
  else if (saved.assigned === false) migrated.push('toAssign');
  if (saved.sourcing === true) migrated.push('sourcing');
  return migrated;
};
